var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropboxUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2494 0L0 4.61857L7.2494 9.23726L14.4999 4.61857L7.2494 0ZM21.7499 0L14.4999 4.61902L21.7499 9.23805L29 4.61902L21.7499 0ZM0 13.8566L7.2494 18.4753L14.4999 13.8566L7.2494 9.23805L0 13.8566ZM21.7499 9.23805L14.4999 13.8571L21.7499 18.476L28.9999 13.8571L21.7499 9.23805ZM7.24997 20.0248L14.5005 24.6434L21.7499 20.0248L14.5005 15.4062L7.24997 20.0248Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxUpload);
export default __webpack_public_path__ + "static/media/dropbox_upload.fbf1fcf2e09ea28e219b8461f90a71e9.svg";
export { ForwardRef as ReactComponent };